import React, { useEffect, useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

/** Dish gallery with a simple lightbox. */
export default function DishGallery({ images = [], title = "" }) {
  const [index, setIndex] = useState(null);

  useEffect(() => {
    if (index === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") setIndex(null);
      if (e.key === "ArrowRight") setIndex((i) => (i + 1) % images.length);
      if (e.key === "ArrowLeft") setIndex((i) => (i - 1 + images.length) % images.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [index, images.length]);

  if (!images.length) return null;

  const move = (d) => setIndex((i) => (i + d + images.length) % images.length);

  return (
    <div className="mt-12" data-testid="dish-gallery">
      <div className="small-caps text-neutral-500 mb-4">From the kitchen</div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {images.map((src, i) => (
          <button key={`${src}-${i}`} onClick={() => setIndex(i)} data-testid={`dish-photo-${i}`}
            className="group relative overflow-hidden border border-white/10 hover:border-[#F5B041]/50 transition">
            <img src={src} alt={`${title} — dish ${i + 1}`} loading="lazy"
              className="w-full aspect-square object-cover transition duration-700 group-hover:scale-105" />
          </button>
        ))}
      </div>

      {index !== null && (
        <div className="fixed inset-0 z-[120] bg-black/95 flex items-center justify-center p-4"
          onClick={() => setIndex(null)} data-testid="dish-lightbox" role="dialog" aria-modal="true">
          <button onClick={() => setIndex(null)} data-testid="dish-lightbox-close"
            className="absolute top-5 right-5 text-neutral-400 hover:text-white"><X size={22} /></button>
          <button onClick={(e) => { e.stopPropagation(); move(-1); }} data-testid="dish-prev"
            className="absolute left-3 sm:left-8 text-white/80 hover:text-white p-3 rounded-full bg-black/60 border border-white/10"><ChevronLeft size={26} /></button>
          <img src={images[index]} alt={`${title} — dish ${index + 1}`}
            onClick={(e) => e.stopPropagation()}
            className="max-h-[85vh] max-w-full object-contain border border-white/10" />
          <button onClick={(e) => { e.stopPropagation(); move(1); }} data-testid="dish-next"
            className="absolute right-3 sm:right-8 text-white/80 hover:text-white p-3 rounded-full bg-black/60 border border-white/10"><ChevronRight size={26} /></button>
          <div className="absolute bottom-5 small-caps text-[11px] text-neutral-300">{index + 1} / {images.length}</div>
        </div>
      )}
    </div>
  );
}
